// src/pages/CheckoutPage.tsx (या src/components/CheckoutPage.tsx)

import React from 'react';
import { useShop } from '../context/ShopContext';
import { useNavigate } from 'react-router-dom';

const CheckoutPage: React.FC = () => {
  const { cartItems } = useShop();
  const navigate = useNavigate();

  const totalAmount = cartItems.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  // यदि कार्ट खाली है, तो उपयोगकर्ता को कार्ट पेज पर वापस भेज दें
  if (cartItems.length === 0) {
    return (
        <div className="container mx-auto px-4 py-20 min-h-screen text-center">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">Cart is Empty!</h1>
            <p className="text-lg text-gray-600 mb-6">Please add items to your cart before proceeding to checkout.</p>
            <button
                onClick={() => navigate('/cart')}
                className="bg-amber-700 text-white py-2 px-6 rounded-md hover:bg-amber-800 transition duration-300 font-semibold"
            >
                Go to Cart
            </button>
        </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12 min-h-screen">
      <h1 className="text-4xl font-extrabold mb-10 text-center text-amber-800">
        Checkout 
      </h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        
        {/* Shipping & Payment Form */}
        <div className="lg:col-span-2 space-y-6 p-6 border rounded-lg shadow-xl bg-white">
          <h2 className="text-2xl font-bold text-gray-800 border-b pb-3 mb-4">Shipping Information</h2>
          <form className="space-y-4">
            <div>
              <label htmlFor="fullName" className="block text-sm font-medium text-gray-700">Full Name</label>
              <input type="text" id="fullName" className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 p-2 border" required />
            </div>
            <div>
              <label htmlFor="address" className="block text-sm font-medium text-gray-700">Address</label>
              <textarea id="address" rows={3} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-amber-500 focus:border-amber-500 p-2 border" required></textarea>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 border-b pb-3 pt-6 mb-4">Payment Method</h2>
            {/* Dummy Payment Options */}
            <div className="space-y-2">
              <label className="flex items-center space-x-2">
                <input type="radio" name="payment" value="cod" className="focus:ring-amber-500 h-4 w-4 text-amber-600 border-gray-300" defaultChecked />
                <span className="text-gray-900">Cash on Delivery (COD)</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="radio" name="payment" value="card" className="focus:ring-amber-500 h-4 w-4 text-amber-600 border-gray-300" disabled />
                <span className="text-gray-400">Credit/Debit Card (Coming Soon)</span>
              </label>
            </div>
          </form>
        </div>

        {/* Order Summary */}
        <div className="lg:col-span-1 p-6 border rounded-lg bg-white shadow-xl h-fit">
          <h2 className="text-2xl font-bold mb-4 border-b pb-2 text-gray-800">Order Details</h2>
          <div className="space-y-3 mb-6 max-h-60 overflow-y-auto">
            {cartItems.map((item) => (
              <div key={item.id} className="flex justify-between text-sm">
                <span className="text-gray-600 truncate mr-2">
                  {item.title} ({item.quantity}x)
                </span>
                <span className="font-medium min-w-[60px] text-right">
                  ₹{(item.price * item.quantity).toFixed(2)}
                </span>
              </div>
            ))}
          </div>

          <div className="flex justify-between border-t pt-4 text-xl font-bold text-amber-800">
            <span>Grand Total</span>
            <span>₹{totalAmount.toFixed(2)}</span>
          </div>

          <button
            type="submit"
            className="w-full mt-6 bg-green-600 text-white py-3 rounded-md hover:bg-green-700 transition duration-300 font-semibold"
          >
            Place Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;